import * as React from 'react';
import { IDpsHomeFeatureCardData } from '../model/IDpsBasicFeature';
import { routes } from '../routing/routes';
import DpsHomeFeatureCard from './DpsHomeFeatureCard';
import DpsTwitterContainer from './DpsTwitterContainer';

export default class DpsHomeSidebarFeatures extends React.PureComponent {

  public render() {
    // Sadly, features have to be initialized in render() because of a circular dependency with routes.
    const features: IDpsHomeFeatureCardData[] = [
      {
        title: 'Get Involved',
        bodyText: `Like dogs? Want to help out in your community? Come volunteer or foster with DPS!`,
        localPath: `${routes.volunteer.path}/${routes.volunteer.children!.faq.path}`,
        imgSrc: '/home/events.jpg?w=700',
        linkText: 'Learn more about how you can help'
      }, {
        title: 'Fur-ever After',
        bodyText: `DPS has matched thousands of dogs with their perfect home over the
        past decade. Read our success stories and if you've adopted one of our
        pups, we'd love to hear from you!`,
        localPath: routes.successStories.path,
        imgSrc: '/home/success-stories.jpg?w=700',
        linkText: 'Read about our Happy Tails'
      }, {
        title: 'We ❤️ Pet Food Express!',
        bodyText: `Thank you to our partner, Pet Food Express, for hosting our adoption
        events in your stores! We couldn't save all of these dogs without you!`,
        externalLink: 'https://www.petfoodexpress.com/',
        imgSrc: '/home/pet-food-express.jpg?w=700',
        linkText: 'Find a PFE near you'
      }, {
        title: 'Our Favorite Doctors',
        bodyText: `Thank you to our vets, who help us keep all of our dogs healthy!`,
        body: <ul>
          <li><a href="https://www.perrisvetclinic.com/" target="_blank" rel="noreferrer">Perris
            Valley Animal Hospital</a></li>
          <li><a href="http://sanjosepetcare.com/" target="_blank" rel="noreferrer">Petcare
            Animal Hospital</a></li>
          <li><a href="http://www.alphapethospital.com/" target="_blank" rel="noreferrer">Dr.
            Peet at Alpha Animal Hospital</a></li>
          <li><a href="https://happyvalleypethospital.com/" target="_blank" rel="noreferrer">
            Dr. Cheung at Happy Valley Pet Hospital</a></li>
          <li><a href="https://villagesquarevet.com/" target="_blank" rel="noreferrer">
            Village Square Portola Valley Veterinary Hospital</a></li>
        </ul>,
        externalLink: 'https://www.petfoodexpress.com/',
        imgSrc: '/home/vets.jpg?w=700'
      },
    ];

    return (
      <div className="col-md-12">
        <div className="hidden-sm hidden-xs">
          <DpsTwitterContainer />
        </div>
        {features.map(feature => <DpsHomeFeatureCard feature={feature} key={feature.title} />)}
      </div>
    );
  }
}
